import React, { useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';
import { getTemplateFolders, changeFoldersSelector } from '../../actions/folders';

const TemplateFolderSelection = ({
  templateFolders,
  getTemplateFolders,
  isLoadTemplateFolders,
  changeFoldersSelector,
  template,
}) => {
  let defaultValue = 'Неразобранное';

  useEffect(() => {
    if (template && template.folder_id) {
      changeFoldersSelector(template.folder_id);
    }
    getTemplateFolders();
  }, []);

  const selectionFolderValue = (e, { value }) => {
    const folder_id = templateFolders.find((folder) => folder.value === value).key;
    changeFoldersSelector(folder_id);
  };

  if (template) {
    defaultValue = template.folder_name;
  }

  return (
    <React.Fragment>
      <Label>Выберите папку</Label>
      <Item>
        <Dropdown
          onChange={selectionFolderValue}
          placeholder="I open on focus"
          openOnFocus
          selection
          options={templateFolders}
          defaultValue={defaultValue}
          loading={isLoadTemplateFolders}
        />
      </Item>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { templateFolders, isLoadTemplateFolders } = state.folders;
  const { template } = state.template;
  return {
    templateFolders,
    isLoadTemplateFolders,
    template,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getTemplateFolders: () => dispatch(getTemplateFolders()),
  changeFoldersSelector: (folder_id) => dispatch(changeFoldersSelector(folder_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplateFolderSelection);

const Item = styled.div`
  width: 100%;
  margin: 15px auto;
  display: flex;
  justify-content: flex-start;
`;
const Label = styled.label`
  width: 100%;
  font-size: 24px;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/Components/TemplateGenerator/TemplateFolderSelection.jsx